"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const react_if_1 = require("react-if");
const react_moment_1 = tslib_1.__importDefault(require("react-moment"));
const react_2 = require("@osmosys/react");
const graphql_1 = require("../../../graphql");
const BaseAuthModal_1 = require("./BaseAuthModal");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
exports.MagicLinkModal = props => {
    const { match } = use_react_router_1.default();
    const queryResult = react_hooks_1.useQuery(graphql_1.isUserTokenValid, {
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
        variables: {
            key: 'magicLinkToken',
            token: match.params.token,
        },
    });
    const { error, loading, data } = queryResult;
    const modal = ({ isValid }) => (react_1.default.createElement(BaseAuthModal_1.BaseAuthModal, Object.assign({ osysSubType: "magicLink", title: loading
            ? 'Loading magic link...'
            : error
                ? 'Failed to load magic link'
                : 'Magic login link', fields: isValid ? [] : ['email'], mutation: isValid ? graphql_1.loginWithMagicLink : graphql_1.sendMagicLink, buttonText: isValid ? 'Login' : 'Request new magic link', emailIsDisabled: isValid, getVars: ({ email }) => isValid
            ? {
                token: match && match.params && match.params.token,
            }
            : {
                email,
            }, isOpen: props.isOpen, linkComp: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_if_1.If, { condition: !!(data && data.isUserTokenValid) },
                react_1.default.createElement(react_if_1.Then, null, () => (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("p", { className: "text-success lead" }, "Magic link is valid!"),
                    react_1.default.createElement("p", { className: "text-muted" },
                        "This link will expire",
                        ' ',
                        react_1.default.createElement(react_moment_1.default, { fromNow: true }, data.isUserTokenValid.magicLinkTokenExpiresAt),
                        ' ',
                        "at",
                        ' ',
                        react_1.default.createElement(react_moment_1.default, { format: "LTS" }, data.isUserTokenValid.magicLinkTokenExpiresAt),
                        ".")))),
                react_1.default.createElement(react_if_1.Else, null,
                    react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "TransactionalEmail", action: "read", apolloError: error }, txt => {
                        return react_1.default.createElement("p", { className: "lead" }, txt);
                    })))) }, props)));
    if (match.params.token) {
        const childResult = {
            isValid: !!(data &&
                data.isUserTokenValid &&
                moment_1.default(data.isUserTokenValid.magicLinkTokenExpiresAt).isAfter(moment_1.default())),
            queryResult,
            user: data && data.isUserTokenValid ? data.isUserTokenValid : undefined,
        };
        return react_1.default.createElement(react_1.default.Fragment, null, modal(childResult));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, modal({
        isValid: null,
    })));
};
exports.default = exports.MagicLinkModal;
//# sourceMappingURL=MagicLinkModal.js.map